import moment from "moment";
import { PopupModal } from "../../../components/Modal";
import Button from "../../../components/Button";
import Spinner from "../../../components/Spinners";
import { ProvisioningUser } from "../types";
import { useConfirmTrackingEmailPreview } from "../hooks/useOnboardingTracking";

export function ConfirmTrackingEmailPreviewModal({
  user,
  onClose,
  onSendConfirm,
  isSending,
}: {
  user: ProvisioningUser;
  onClose: () => void;
  onSendConfirm: () => void;
  isSending: boolean;
}) {
  const preview = useConfirmTrackingEmailPreview(user.userId, true);
  const alreadyConfirmed = user.selfServeVerifiedAt
    ? moment(user.selfServeVerifiedAt)
    : null;

  return (
    <PopupModal
      onClose={onClose}
      contentClassName="!p-0 w-full max-w-[760px] max-h-[90vh] overflow-hidden mx-auto"
    >
      <div className="flex flex-col max-h-[90vh]">
        <div className="px-6 py-4 border-b border-border-primary shrink-0">
          <div className="text-xs font-medium text-content-secondary uppercase mb-1">
            Subject:
          </div>
          <div className="font-semibold text-content-primary">
            {preview.data?.subject ?? (preview.isLoading ? "Loading…" : "—")}
          </div>
        </div>

        <div className="flex-1 min-h-0 overflow-hidden bg-surface-secondary">
          {preview.isLoading ? (
            <div className="flex items-center justify-center h-[70vh]">
              <Spinner className="text-brand-primary" />
            </div>
          ) : preview.isError ? (
            <div className="flex items-center justify-center h-[70vh] px-6 text-center text-sm text-red-700">
              Couldn't load the email preview. Please try again.
            </div>
          ) : (
            <iframe
              title="Email preview"
              srcDoc={preview.data?.html ?? ""}
              className="w-full h-[70vh] border-0 bg-white"
            />
          )}
        </div>

        <div className="px-6 py-4 border-t border-border-primary flex items-center gap-3 justify-end flex-wrap shrink-0">
          {alreadyConfirmed && (
            <span className="text-emerald-700 text-sm mr-auto">
              Already confirmed {alreadyConfirmed.fromNow()}
            </span>
          )}
          <Button variant="outline" size="sm" onClick={onClose}>
            Close
          </Button>
          {!alreadyConfirmed && (
            <Button size="sm" loading={isSending} onClick={onSendConfirm}>
              Send &amp; confirm
            </Button>
          )}
        </div>
      </div>
    </PopupModal>
  );
}
